var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"large":""}},[_vm._v("Delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }